import styled from 'styled-components';

import { theme } from '../../../../global';

export const StyledButton = styled.button<{ $bgColor: string }>`
  width: 182px;
  height: 72px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.white};
  font-size: 18px;
  font-weight: 600;
  background-color: ${({ $bgColor }) => $bgColor};

  &:disabled {
    cursor: default;
    opacity: 0.8;
  }
`;
